"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSearchParamsForConfiguration = void 0;
function encodeArray(params) {
    return params.map((param) => param.replace(/-/g, '%2D')).join('-');
}
function createSearchParamsForConfiguration(configuration) {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(configuration)) {
        if (typeof value === 'string') {
            params.set(key, value);
        }
        if (Array.isArray(value) && value.length > 0) {
            params.set(key, encodeArray(value));
        }
    }
    return params;
}
exports.createSearchParamsForConfiguration = createSearchParamsForConfiguration;
//# sourceMappingURL=configuration-search-params.js.map